import { render, staticRenderFns } from "./newAboutUs.vue?vue&type=template&id=272d4bd4&scoped=true&"
import script from "./newAboutUs.vue?vue&type=script&lang=js&"
export * from "./newAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./newAboutUs.vue?vue&type=style&index=0&id=272d4bd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272d4bd4",
  null
  
)

export default component.exports